import { useAppDispatch, useAppSelector } from "./index";
import { useContext, useEffect, useState } from "react";
import { ensContext } from "../contexts/ENSContext";
import { setEnsNames } from "../store/reducers/asset";

interface IProps {
  address?: string;
  ensName?: string;
}

const useENS = ({ address, ensName }: IProps) => {
  const { ens } = useContext(ensContext);
  const [result, setResult] = useState<string>("");
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const ensNames = useAppSelector((state) => state.asset.ensNames);
  const dispatch = useAppDispatch();

  const handleResult = (req: string, res: string) => {
    if (req && res) {
      setResult(res);
      dispatch(setEnsNames({ ...ensNames, [req]: res, [res]: req }));
    }
  };

  const getResult = async () => {
    try {
      if (address) {
        if (ensNames[address]) {
          setResult(ensNames[address]);
          return;
        }
        const r = await ens.getName(address);
        setIsFetching(false);
        handleResult(address, r?.name);
      }
      if (ensName) {
        if (ensNames[ensName]) {
          setResult(ensNames[ensName]);
          return;
        }
        const r = await ens.getOwner(ensName);
        setIsFetching(false);
        handleResult(ensName, r);
      }
    } catch (e) {
      setIsFetching(false);
      console.error(e);
    }
  };

  useEffect(() => {
    if (!ens) return;
    getResult();
  }, [ens]);

  return { result, isFetching };
};

export default useENS;
